import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuongtien from "components/Danhmuc/Phuongtien/Phuongtien.js";
export default function Dmphuongtien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phương tiện đường bộ",
            tabContent: <Phuongtien />,
          },
        ]}
      />
    </div>
  );
}
